import { FunctionFactory } from "survey-core";
import buildCompositionSummary from "./build-composition-summary";
import buildMaterialsInfoSummary from "./build-materials-info-summary";
import buildYarnSuppliersSummary from "./build-yarn-suppliers-summary";
import composeBomT1DialogQuestionTitle from "./compose-bom-t1-dialog-question-title";
import formatCurrency from "./format-currency";
import containsOnlyOneSpecialFabricProcess from "./contains-only-one-special-fabric-process";
import isUnitVisibleForVehicles from "./is-unit-visible-for-vehicles";

FunctionFactory.Instance.register(
  "buildCompositionSummary",
  buildCompositionSummary,
  true
);

FunctionFactory.Instance.register(
  "buildMaterialsInfoSummary",
  buildMaterialsInfoSummary,
  true
);

FunctionFactory.Instance.register(
  "buildYarnSuppliersSummary",
  buildYarnSuppliersSummary,
  true
);

FunctionFactory.Instance.register(
  "composeBomT1DialogQuestionTitle",
  composeBomT1DialogQuestionTitle,
  true
);

FunctionFactory.Instance.register("formatCurrency", formatCurrency);

FunctionFactory.Instance.register(
  "containsOnlyOneSpecialFabricProcess",
  containsOnlyOneSpecialFabricProcess
);

FunctionFactory.Instance.register(
  "isUnitVisibleForVehicles",
  isUnitVisibleForVehicles
);
